/*
 * GrowthBook A/B test core (shared by all tests).
 *
 * PATTERN:
 *   - HOLDOUT_FLAG + checkHoldout() at module scope
 *   - single growthbook_queue push that calls checkHoldout() + applyFeatureFlags()
 *   - applyFeatureFlags() calls each test's reader by name (window.applyXxx)
 *
 * Each individual test lives in assets/growthbook-<name>.js and exposes
 * window.applyXxx; this file just calls it.
 *
 * TO ADD A NEW TEST:
 *   1. Create assets/growthbook-<name>.js that exposes window.applyNewTest
 *   2. Add `if (window.applyNewTest) window.applyNewTest(gb);` inside
 *      applyFeatureFlags() below
 *   3. Add the <script src> for the new file in layout/theme.liquid
 *
 * Holdout: feature flag 'holdout-q3-hb' (boolean, 5% Holdout / 95% Exposed).
 * To change: update HOLDOUT_FLAG here — no test file needs to change.
 *
 * The pre-first-paint bootstrap for plp_layout_v2 stays inline in
 * layout/theme.liquid (historical, not migrated).
 */

const holdout = 'holdout-q3-hb';

const checkHoldout = _ => {
  const holdoutGroup = window._growthbook?.getFeatureValue(holdout, 'OFF');

  if (holdoutGroup === true) {
    document.documentElement.classList.add('ab-enabled');
    window.ab_enabled = true;
  }
};

(() => {
  window.growthbook_queue = window.growthbook_queue || [];
  window.growthbook_queue.push((gb) => {
    // Function that uses feature flags to make changes to the page
    const applyFeatureFlags = () => {
      // call here flags:
      if (window.applyPlpSubcategoryCarousel) window.applyPlpSubcategoryCarousel(gb);
      if (window.applySizeGuide) window.applySizeGuide(gb);
    };

    // check holdout to set ab test
    checkHoldout();

    // Call your function initially plus whenever new data is received
    applyFeatureFlags();
    document.addEventListener('growthbookdata', _ => {
      checkHoldout();
      applyFeatureFlags();
    });
  });
})();
